// @docs https://[domain]/api/v1/docs
export default {
  List: "/pyr/leave-types",
  ListShort: "/pyr/leave-types/short",
  Create: "/pyr/leave-types",
  Update: "/pyr/leave-types",
};
